import type { ReactNode } from "react";

import useTranslation from "../../hooks/useTranslation";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./ErrorPage.module.css";

const ErrorPage: React.FC = () => {
  const { t, m } = useTranslation();

  return (
    <div className={style.container}>
      <img
        src="https://s3-eu-west-1.amazonaws.com/shapr3d-assets/images/engine-model.png"
        alt=""
        className={style.illustration}
      />
      <div className={style.message}>
        {t(m.ErrorMessage.SomethingWentWrongSupport, {
          supportLink: (chunks: ReactNode) => (
            <NewZendeskTicketLink>
              <span className={style.link}>{chunks}</span>
            </NewZendeskTicketLink>
          ),
        })}
      </div>
    </div>
  );
};

export default ErrorPage;
